module.exports = __webpack_public_path__ + "img/Costa Rica.72135a57.svg";